import { useState } from "react";
import { Button } from "react-bootstrap";

// The insight stage component contains a single button that presents the user with a quiz
export default function InsightStage() {
  const [bubbleVisible, setBubbleVisible] = useState(false);
  const [questionIdx, setQuestionIdx] = useState(0);
  const [answerVisible, setAnswerVisible] = useState(false);

  // The quiz questions
  const questions = [
    "When you compare the line graphs of two data sets, they seem to move in similar ways. Could they be dependent on each other? What is happening here?",
    // "What is the largest temperature difference you can find between two graphs? Try to choose the cooling methods and house types in a smart way to find it!",
    "Look at the scatter plot. During which part of the day is temperature the highest?",
    "During which part of day is temperature the lowest?",
    "Can you see when were the warmest days of the summer?"
  ];

  // The quiz answers, corresponding to the questions by index
  const answers = [
    "The lines are not dependent on each other, but the shapes are similar because of the temperature difference between day and night! This means the graphs are correlated, but they do not cause each other.",
    // "The lowest temperature was 16.2℃ and happened in a terraced house with closed curtains during the day and open windows at night, on the 24th of June.\nThe highest temperature was 43.6℃ and happened in a porch house or apartment with closed curtains during the day and the windows always open, on the 7th of July.",
    "The temperature in houses is often the highest in the early evening. Although the temperature outside is already cooling by then, the temperature inside is high because of the accumulated heat.",
    "In the early morning the temperature is the lowest, as it is cold outside and the house had time to cool down during the night.",
    "The days around 20-25 of July are the hottest. However you can also see high temperature in the middle of June."
  ];

  function prevQuestion() {
    if (questionIdx > 0) {
      setQuestionIdx(questionIdx - 1);
      setAnswerVisible(false);
    }
  }

  function nextQuestion() {
    if (questionIdx < questions.length-1) {
      setQuestionIdx(questionIdx + 1);
      setAnswerVisible(false);
    }
  }

  return (
    <div style={{ margin: "auto" }}>
      <div className="speech bubble" style={{ display: (bubbleVisible ? "block" : "none") }}>
        <div>{ answerVisible ? answers[questionIdx] : questions[questionIdx] }</div>
        <div style={{ display: "flex", justifyContent: "space-between", marginTop: "1em"}}>
          <div>
            <Button size="sm" disabled={ questionIdx <= 0} onClick={ prevQuestion }>{"<"}</Button>
          </div>
          <div>
            <Button size="sm" onClick={ () => {setAnswerVisible(!answerVisible)} }>Answer!</Button>
          </div>
          <div>
          <Button size="sm" disabled={ questionIdx >= questions.length - 1} onClick={ nextQuestion }>{">"}</Button>
          </div>
        </div>
      </div>
      <Button
        size="lg"
        onClick={ () => { setBubbleVisible(!bubbleVisible); } }
      >
        Quiz!
      </Button>
    </div>
  );
}